<template>
  <div class="edit-view display-in-center view" v-loading.fullscreen="loading || !isReadyToScan">
    <div class="step-label">
      {{ $t('unpairing_barcodes') }}
    </div>
    <div class="barcode-scanner relative">
      <div id="scan-area">
        <div class="scan-selection-camera" @click="openDialog" v-show="cameras.length > 0">
          <IconSwitch />
        </div>
        <div id="video-area">
          <video playsinline autoplay id="video"></video>
        </div>
      </div>

      <BarcodeSymbologiesSelection
        class="absolute bottom-2 z-50 left-2 flex w-52"
        @update:onSymbologiesChange="setBarcodeSymbologies"
        v-model:symbologies="symbologies"
      />

      <ScanArea />
    </div>
    <div class="barcode-number-block">
      <span>
        {{ $t('Number of Scanned Barcodes') }}
      </span>
      <span class="label-box" @click="onCheckScannedBarcode">
        {{ scannedBarcodeList.length }}
      </span>
    </div>
    <el-button
      circle
      :disabled="scannedBarcodeList.length === 0"
      type="primary"
      class="submit-button"
      @click="submit()"
    >
      {{ $t('OK') }}
    </el-button>
  </div>
  <SelectionCameraPopup v-model:selectedCamera="selectedCamera" :cameras="cameras" v-model:isShow="isOpenDialog" />
</template>
<script lang="ts">
import BarcodeLabelList from '@/components/BarcodeLabelList.vue'
import BarcodeSymbologiesSelection from '@/components/BarcodeSymbologiesSelection.vue'
import MultipleBarcodeScanMixin from '@/components/mixins/MultipleBarcodeScanMixin.vue'
import ScanArea from '@/components/svg/ScanArea.vue'
import { FETCH_BARCODE, SAVE_SCANNED_BARCODES, UNPAIRING } from '@/store/actions'
import { unpairBarcode } from '@/utils/api'
import { Options } from 'vue-class-component'
import { Mixins } from 'vue-property-decorator'
import { RouteLocationNormalized, NavigationGuardNext } from 'vue-router'
import SelectionCameraPopup from '@/components/dialog/SelectionCameraPopup.vue'
import IconSwitch from '@/components/svg/IconSwitch.vue'
import { IBarcodeDefinitionType } from '@/utils/types/fieldDefinition'
import { IBarcode } from '@/utils/types/barcodeTypes'
@Options({
  components: {
    ScanArea,
    BarcodeLabelList,
    BarcodeSymbologiesSelection,
    IconSwitch,
    SelectionCameraPopup,
  },
  emits: [],
  name: 'BarcodeUnpairScan',
})
export default class BarcodeUnpairScan extends Mixins(MultipleBarcodeScanMixin) {
  loading = false
  dialogVisible = false
  isReadyToScan = true

  async created() {
    this.isForcedHideMultipleScan = true
    this.loading = true
    await this.getBarcodeInfo()
    this.loading = false
  }

  async beforeRouteLeave(to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) {
    await this.onLeaveGuard(to, from, next)
  }

  async getBarcodeInfo() {
    if (this.$route.params?.barcodeId && this.$route.params?.project) {
      await this.$store.dispatch(FETCH_BARCODE, { id: this.$route.params?.barcodeId })
    }
  }

  get barcode() {
    return this.$store.state.barcode.barcode
  }

  onCheckScannedBarcode() {
    this.checkScannedBarcode = true
    this.dialogVisible = true
  }

  onCloseDialog() {
    this.dialogVisible = false
    this.checkScannedBarcode = false
  }

  barcodeTypeInfo(barcodeType: string): Record<string, IBarcodeDefinitionType> {
    return this.$store.state.project?.details?.barcodeTypes[barcodeType]
  }

  async validateBarcode(resultScanned: IBarcode) {
    if (this.barcode.id === resultScanned.id) throw this.$t('barcode_unpairing_by_itself_error')

    const currentProjectId = this.$store.state.project.details.id
    const scannedBCProjectId = resultScanned.projectId
    if (currentProjectId !== scannedBCProjectId) throw this.$t('scanned_barcode_not_same_project')

    if (!resultScanned.isActivated) throw this.$t('barcode not activated')

    await unpairBarcode({
      parentBarcodeId: this.barcode.id,
      isUnpairAll: false,
      unpairChildrenIds: [resultScanned?.id],
      isDryRun: true,
    })
  }

  forward() {
    this.$store.dispatch(SAVE_SCANNED_BARCODES, this.barcodes)
    this.$router.push({
      name: 'scanned-barcode-list',
      params: {
        title: this.$t('unpairing_read_result'),
        operation: UNPAIRING,
      },
    })
  }
}
</script>
<style lang="scss" scoped>
@import './src/assets/css/mixins.scss';

.edit-view.view {
  padding-left: 0;
  padding-right: 0;
}

.step-label {
  margin-bottom: 25px;
}

.barcode-scanner {
  height: 430px;
  background: rgb(32, 32, 32);
  position: relative;
}

.barcode-scanner video {
  width: 100%;
  height: 100%;
}

.scan-selection-camera {
  position: absolute;
  top: 0.5em;
  left: 0.5em;
}
</style>
